<script>
import { computed, defineComponent } from '@vue/composition-api';
import SellersStoreSelect from './SellersStoreSelect.vue';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';

export default defineComponent({
  components: {
    SellersStoreSelect,
  },
  setup(props, { root }) {
    const profile = computed(() => root.$store.getters.getProfile);
    const {
      storeSelected,
      changeStoreSelected,
    } = useManagerDashboard();
    const { stores: sellerStores, loading: loadingStores } = useVuexSellerStores(root);

    return {
      storeSelected,
      changeStoreSelected,
      sellerStores,
      loadingStores,
      profile,
    };
  },
});
</script>

<template>
  <div class="header">
    <v-layout
      row
      justify-space-between
      align-center
    >
      <TitleChip title="Gestão de Usuários" />
      <v-btn
        fab
        small
        flat
        style="background-color: #FFADDE"
        :to="`/sellers/new`"
      >
        <v-icon small>
          $vuetify.icons.userPlusIcon
        </v-icon>
      </v-btn>
    </v-layout>

    <SellersStoreSelect
      :change-store-selected="changeStoreSelected"
      :loading="loadingStores"
      :stores="sellerStores"
      :store-selected="storeSelected"
    />
  </div>
</template>
